/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
const alimonyTranslations = {
  label: "Unterhalt",
  children: {
    childOf: {
      petitioner: "Mein Kind",
      partner: "Kind meines Partners",
      both: "Gemeinsames Kind",
    },
    livesWith: {
      petitioner: "mir",
      partner: "meinem Partner",
      both: "uns",
      none: "einer anderen Person",
    },
    childAllowanceReceiver: {
      petitioner: "ich",
      partner: "mein Partner",
      child: "das Kind selbst",
      none: "keiner",
    },
  },
  alimonyPetitioner: {
    netIncome: {
      label: "Nettoeinkommen",
      helperText: "pro Monat",
    },
    otherIncome: {
      label: "Sonstiges (Natural)einkommen",
      helperText: "pro Monat",
    },
    livingExpenses: {
      label: "Warmmiete",
      helperText: "pro Monat",
    },
    otherExpenses: {
      label: "Sonstige Ausgaben",
      helperText: "pro Monat",
    },
  },
  alimonyPartner: {
    netIncome: {
      label: "Nettoeinkommen",
      helperText: "Pro Monat - Sollten Sie dies nicht genau wissen, geben Sie eine Schätzung oder einfach 0 € an.",
    },
    otherIncome: {
      label: "Sonstiges (Natural)einkommen",
      helperText: "Pro Monat - Sollten Sie dies nicht genau wissen, geben Sie eine Schätzung oder einfach 0 € an.",
    },
    livingExpenses: {
      label: "Warmmiete",
      helperText: "Pro Monat - Sollten Sie dies nicht genau wissen, geben Sie eine Schätzung oder einfach 0 € an.",
    },
    otherExpenses: {
      label: "Sonstige Ausgaben",
      helperText: "Pro Monat - Sollten Sie dies nicht genau wissen, geben Sie eine Schätzung oder einfach 0 € an.",
    },
  },
};

export default alimonyTranslations;
